import { actionGenerator, IReduxAction } from '../../../actionGenerator';
import { IPublishTermsSuccesPayload } from '../../../types/publishTermsPayload';

export const LOAD_PUBLISH_TERMS_SUCCESS = 'PUBLISH_TERMS :: LOAD_SUCCESS';

export type TLoadPublishTermsSuccessAction = IReduxAction<
  typeof LOAD_PUBLISH_TERMS_SUCCESS,
  IPublishTermsSuccesPayload
>;

export const loadPublishTermsSuccess = actionGenerator<typeof LOAD_PUBLISH_TERMS_SUCCESS, IPublishTermsSuccesPayload>(
  LOAD_PUBLISH_TERMS_SUCCESS,
);
